__turbopack_context__.v({
  "root": "lg0orW_root" + " " + __turbopack_context__.i(95264)["paragraphStyles"],
});
